import React, { useContext, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RegisterSidebar from "../../component/RegisterSidebar";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import Input from "../../component/Input";
import { GrFormNextLink, GrFormPreviousLink } from "react-icons/gr";
import { AuthUserContext } from "../../context/context";
import Spinner from "react-bootstrap/esm/Spinner";
import { Link, useLocation, useNavigate } from "react-router-dom";
import verifyOTP from "../../services/auth/verifyOTP";
import { toast } from "react-toastify";
import { AUTH_TOKEN_KEY, USER_DETAILS } from "../../constants/localstorageKeys";
import resendOTP from "../../services/auth/resendOTP";
import authLogo from "../../assets/images/auth-logo.svg";
import LanguageSelect from "../../component/LanguageSelect";
import { IoMdArrowBack } from "react-icons/io";
import { useEffect } from "react";
import PhoneNumberverifyModal from "../../component/PhoneNumberverifyModal";
import PhoneWithGoogle from "../phone-wtih-google";
import ChangePhoneModal from "../../component/ChangePhoneModal";
const OtpVerification = ({
  setEventTriggered,
  hideSidebar,
  isModal,
  handleClose,
  setIsModalShow,
}) => {
  const { t } = useTranslation();
  const {
    currentLocalization,
    setUser,
    linkCopy,
    topUpLink,
    setTopUpLink,
    setLinkCopy,
    setToastId,
    toastId,
    outSideUserPhoneNo,
    googlePhoneNo,
    setUserGoogleId,
  } = useContext(AuthUserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const phoneNo = location.state?.phone_no;
  const userId = location.state?.userId;
  const user = JSON.parse(localStorage.getItem(USER_DETAILS));
  const [validated, setValidated] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpValidation, setOtpValidation] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [isModalShowChangePhoneNo, setIsModalShowChangePhoneNo] =
    useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const userPhone = outSideUserPhoneNo
        ? outSideUserPhoneNo
        : phoneNo
        ? phoneNo
        : googlePhoneNo
        ? googlePhoneNo
        : user?.phoneNo;
      if (!otpValue) {
        setValidated(true);
        return;
      }
      setOtpValidation(false);
      let lang;
      if (currentLocalization.startsWith("en-")) {
        lang = "en";
      } else {
        lang = currentLocalization;
      }
      setLoading(true);
      const object = {
        phone_no: userPhone,
        otp: otpValue,
        lang: lang,
      };
      if (userPhone) {
        const response = await verifyOTP(object);
        if (response) {
          const userDetails = {
            id: response?.data?.id,
            email: response?.data?.email,
            name: response?.data?.name,
            role: response?.data?.role,
            phoneNo: response?.data?.phone_no,
            otpVerified: response?.data?.phoneOtpVerified,
            countries: response?.data?.countries,
            referralCode: response?.data?.referralCode,
            parent_id: response?.data?.parent_id ?? null,
            isFreeSim: response?.data?.isFreeSim,
          };
          setUserGoogleId("");
          localStorage.setItem(USER_DETAILS, JSON.stringify(userDetails));
          localStorage.setItem(AUTH_TOKEN_KEY, response?.data?.token);
          setUser(userDetails);
          localStorage.setItem(AUTH_TOKEN_KEY, response?.data?.token);
          if (linkCopy) {
            navigate(`/offer-detail${linkCopy}`);
          } else if (topUpLink) {
            navigate("/top-up");
          } else if (isModal) {
            handleClose(true);
            setIsModalShow(false);
            localStorage.setItem("OUTSIDER_USER", "partnerUser");
          } else {
            const id = toast.success(response.message, {
              autoClose: false,
              closeOnClick: false,
              draggable: false,
              pauseOnHover: true,
            });
            setToastId(id);
            navigate("/data-usage");
          }
        }
      } else {
        const id = toast.error(t("toastsMessage.part2"), {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      }
    } catch (err) {
      console.error(err);
      if (err.response?.status == 400) {
        const id = toast.error(err.response?.data?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      } else if (err.response?.status == 404) {
        const id = toast.error(err.response?.data?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      } else {
        const id = toast.error(err?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleOtpChange = (event) => {
    setOtpValidation(false);
    const { name, value } = event.target;
    if (value.length > 6) {
      setOtpValidation(true);
      return;
    }
    setOtpValue(value);
  };
  const resendOtp = async () => {
    if (resendTimer > 0) return; // Prevent resending during countdown

    try {
      const userPhone = outSideUserPhoneNo
        ? outSideUserPhoneNo
        : phoneNo
        ? phoneNo
        : googlePhoneNo
        ? googlePhoneNo
        : user?.phoneNo;

      let lang;
      if (currentLocalization.startsWith("en-")) {
        lang = "en";
      } else {
        lang = currentLocalization;
      }
      const object = {
        phone_no: userPhone,
        lang: lang,
      };
      if (userPhone) {
        const response = await resendOTP(object);
        if (response) {
          setResendTimer(10);
          const id = toast.success(response?.message, {
            autoClose: false,
            closeOnClick: false,
            draggable: false,
            pauseOnHover: true,
          });
          setToastId(id);
        }
      } else {
        const id = toast.error(t("toastsMessage.part2"), {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      }
    } catch (err) {
      if (err.response?.status == 404) {
        const id = toast.error(err.response?.data?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      } else {
        const id = toast.error(err?.message, {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
          pauseOnHover: true,
        });
        setToastId(id);
      }
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !loading) {
      if (toastId && typeof setEventTriggered === "function") {
        setEventTriggered(true);
      }
      event.preventDefault();
      handleSubmit(event);
    }
  };
  useEffect(() => {
    if (userId) {
      setUserGoogleId(userId);
    }
  }, [userId]);
  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [resendTimer]);
  return (
    <Container fluid className={isModal ? "" : "main-login-image"}>
      <Row className={isModal ? "" : "row-login d-flex justify-content-center"}>
        {!isModal && !hideSidebar && (
          <Col xs={12} md={6} className="loginImage p-0 ">
            <RegisterSidebar />
          </Col>
        )}

        <Col
          xs={12}
          md={isModal ? 12 : 6}
          className={
            isModal ? "text-start login-side-modal" : "text-start login-side"
          }
        >
          <Row
            className={`d-flex justify-content-center align-items-center pt-${
              !isModal ? 5 : 0
            }`}
          >
            <Col
              md={9}
              className={`pt-0 p-md-0 p-4 d-flex align-items-center justify-content-between ${
                currentLocalization == "ar" && "flex-row-reverse"
              }`}
            >
              {!isModal && (
                <>
                  <Link
                    to="/"
                    onClick={() => {
                      setLinkCopy("");
                      setTopUpLink("");
                    }}
                  >
                    <img src={authLogo} alt="" />
                  </Link>
                  <LanguageSelect />
                </>
              )}
            </Col>
            {!isModal && (
              <Col xs={12} md={9} className="pt-4 p-0">
                <Link to="/sign-up" style={{ color: "#000" }}>
                  <IoMdArrowBack size={30} />
                </Link>
              </Col>
            )}
          </Row>
          <Row className="d-flex justify-content-center align-items-center pt-5 pb-5 large-screen">
            <Col md={isModal ? 11 : 9} className="pt-0 p-md-0 p-4">
              <div
                style={{ marginTop: "15px" }}
                className={`p-0 ${
                  currentLocalization == "ar" ? "text-end" : "text-start"
                }`}
              >
                <h2
                  className="login-welcome"
                  style={{ display: isModal ? "none" : "block" }}
                >
                  {t("otpVerification.part1")}
                </h2>
                <span className="login-information">
                  {t("otpVerification.part2")}
                </span>
                <Form
                  onSubmit={handleSubmit}
                  method="post"
                  onKeyDown={handleKeyDown}
                  className={!isModal && "mt-4"}
                >
                  <Form.Group as={Col} md="12" className="d-flex flex-column">
                    <Input
                      labelClassName="label"
                      labelText={t("otpVerification.part5")}
                      type="number"
                      name="name"
                      value={otpValue}
                      onChange={handleOtpChange}
                      placeholder={t("otpVerification.part5")}
                      className={
                        currentLocalization == "ar"
                          ? "login-input-right"
                          : "login-input-left"
                      }
                    />
                    <div
                      className={
                        currentLocalization == "ar"
                          ? "text-end mt-2"
                          : "text-start mt-2"
                      }
                    >
                      {validated && !otpValue ? (
                        <span className="text-danger">
                          {t("validation.otpVerification")}
                        </span>
                      ) : (
                        otpValidation && (
                          <span className="text-danger">
                            {t("validation.otpValidation")}
                          </span>
                        )
                      )}
                    </div>
                  </Form.Group>
                  <div
                    className={`mt-1 d-flex align-items-center  ${
                      currentLocalization == "ar"
                        ? "flex-row-reverse justify-content-end"
                        : "flex-row justify-content-end"
                    }`}
                  >
                    <div>
                      <span
                        className="forget-password"
                        onClick={resendOtp}
                        style={{
                          cursor: resendTimer > 0 ? "not-allowed" : "pointer",
                          color: resendTimer > 0 ? "#aaa" : "#696969ff",
                          pointerEvents: resendTimer > 0 ? "none" : "auto",
                        }}
                      >
                        {resendTimer > 0
                          ? `${t("YouCanResendTheOTP")} ${resendTimer} ${t(
                              "seconds"
                            )}`
                          : t("otpVerification.part3")}
                      </span>
                    </div>
                  </div>
                  <div
                    className={`mt-1 d-flex align-items-center mt-3  ${
                      currentLocalization == "ar"
                        ? "flex-row-reverse justify-content-end"
                        : "flex-row justify-content-start"
                    }`}
                  >
                    <div>
                      <span
                        className="forget-password"
                        // onClick={resendOtp}
                        style={{
                          cursor: resendTimer > 0 ? "not-allowed" : "pointer",
                          color: resendTimer > 0 ? "#aaa" : "#696969ff",
                          pointerEvents: resendTimer > 0 ? "none" : "auto",
                        }}
                      >
                        {t("Didn'tReceiveTheCode")}{" "}
                        <span
                          style={{ cursor: "pointer", color: "#127aeaff" }}
                          onClick={() => {
                            setIsModalShowChangePhoneNo(true);
                          }}
                        >
                          {t("changePhoneNumber")}
                        </span>
                      </span>
                    </div>
                  </div>
                  <Row style={{ marginTop: "20px" }}>
                    <Col>
                      <div className="d-grid gap-2 ">
                        <button
                          className={
                            loading
                              ? "btn-login-main-disabled"
                              : "btn-login-main"
                          }
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              {currentLocalization == "ar" ? (
                                <>
                                  <span className="me-2">
                                    ... {t("login.part16")}
                                  </span>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                </>
                              ) : (
                                <>
                                  <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                  <span className="ms-2">
                                    {t("login.part16")} ...
                                  </span>
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {currentLocalization == "ar" ? (
                                <>
                                  <GrFormPreviousLink
                                    size={27}
                                    className="me-1"
                                  />
                                  {t("otpVerification.part4")}
                                </>
                              ) : (
                                <>
                                  {t("otpVerification.part4")}
                                  <GrFormNextLink size={27} className="ms-1" />
                                </>
                              )}
                            </>
                          )}
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>

              <ChangePhoneModal
                isModalShowChangePhoneNo={isModalShowChangePhoneNo}
                setIsModalShowChangePhoneNo={setIsModalShowChangePhoneNo}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default OtpVerification;
